const auth = {
    PWD_RST: 'NEW_PASSWORD_REQUIRED',
    MFA: 'SMS_MFA',
};

Object.freeze(auth)

export default auth
